"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PeruProvince = exports.usaProvinceToStateCode = exports.UsaProvince = exports.MexicoProvince = exports.CanadaProvince = void 0;
var CanadaProvince;
(function (CanadaProvince) {
  CanadaProvince["ALBERTA"] = "Alberta";
  CanadaProvince["BRITISH_COLUMBIA"] = "British Columbia";
  CanadaProvince["MANITOBA"] = "Manitoba";
  CanadaProvince["NEW_BRUNSWICK"] = "New Brunswick";
  CanadaProvince["NEWFOUNDLAND_AND_LABRADOR"] = "Newfoundland and Labrador";
  CanadaProvince["NOVA_SCOTIA"] = "Nova Scotia";
  CanadaProvince["ONTARIO"] = "Ontario";
  CanadaProvince["PRINCE_EDWARD_ISLAND"] = "Prince Edward Island";
  CanadaProvince["QUEBEC"] = "Quebec";
  CanadaProvince["SASKATCHEWAN"] = "Saskatchewan";
  CanadaProvince["NORTHWEST_TERRITORIES"] = "Northwest Territories";
  CanadaProvince["NUNAVUT"] = "Nunavut";
  CanadaProvince["YUKON"] = "Yukon";
})(CanadaProvince || (exports.CanadaProvince = CanadaProvince = {}));
var MexicoProvince;
(function (MexicoProvince) {
  MexicoProvince["AGUASCALIENTES"] = "Aguascalientes";
  MexicoProvince["BAJA_CALIFORNIA"] = "Baja California";
  MexicoProvince["BAJA_CALIFORNIA_SUR"] = "Baja California Sur";
  MexicoProvince["CAMPECHE"] = "Campeche";
  MexicoProvince["CHIAPAS"] = "Chiapas";
  MexicoProvince["CHIHUAHUA"] = "Chihuahua";
  MexicoProvince["COAHUILA"] = "Coahuila";
  MexicoProvince["COLIMA"] = "Colima";
  MexicoProvince["DURANGO"] = "Durango";
  MexicoProvince["GUANAJUATO"] = "Guanajuato";
  MexicoProvince["GUERRERO"] = "Guerrero";
  MexicoProvince["HIDALGO"] = "Hidalgo";
  MexicoProvince["JALISCO"] = "Jalisco";
  MexicoProvince["MEXICO"] = "Mexico";
  MexicoProvince["MEXICO_CITY"] = "Mexico City";
  MexicoProvince["MICHOACAN"] = "Michoacan";
  MexicoProvince["MORELOS"] = "Morelos";
  MexicoProvince["NAYARIT"] = "Nayarit";
  MexicoProvince["NUEVO_LEON"] = "Nuevo Leon";
  MexicoProvince["OAXACA"] = "Oaxaca";
  MexicoProvince["PUEBLA"] = "Puebla";
  MexicoProvince["QUERETARO"] = "Queretaro";
  MexicoProvince["QUINTANA_ROO"] = "Quintana Roo";
  MexicoProvince["SAN_LUIS_POTOSI"] = "San Luis Potosi";
  MexicoProvince["SINALOA"] = "Sinaloa";
  MexicoProvince["SONORA"] = "Sonora";
  MexicoProvince["TABASCO"] = "Tabasco";
  MexicoProvince["TAMAULIPAS"] = "Tamaulipas";
  MexicoProvince["TLAXCALA"] = "Tlaxcala";
  MexicoProvince["VERACRUZ"] = "Veracruz";
  MexicoProvince["YUCATAN"] = "Yucatan";
  MexicoProvince["ZACATECAS"] = "Zacatecas";
})(MexicoProvince || (exports.MexicoProvince = MexicoProvince = {}));
var UsaProvince;
(function (UsaProvince) {
  UsaProvince["ALABAMA"] = "Alabama";
  UsaProvince["ALASKA"] = "Alaska";
  UsaProvince["AMERICAN_SAMOA"] = "American Samoa";
  UsaProvince["ARIZONA"] = "Arizona";
  UsaProvince["ARKANSAS"] = "Arkansas";
  UsaProvince["CALIFORNIA"] = "California";
  UsaProvince["COLORADO"] = "Colorado";
  UsaProvince["CONNECTICUT"] = "Connecticut";
  UsaProvince["DELAWARE"] = "Delaware";
  UsaProvince["DISTRICT_OF_COLUMBIA"] = "District of Columbia";
  UsaProvince["FLORIDA"] = "Florida";
  UsaProvince["GEORGIA"] = "Georgia";
  UsaProvince["GUAM"] = "Guam";
  UsaProvince["HAWAII"] = "Hawaii";
  UsaProvince["IDAHO"] = "Idaho";
  UsaProvince["ILLINOIS"] = "Illinois";
  UsaProvince["INDIANA"] = "Indiana";
  UsaProvince["IOWA"] = "Iowa";
  UsaProvince["KANSAS"] = "Kansas";
  UsaProvince["KENTUCKY"] = "Kentucky";
  UsaProvince["LOUISIANA"] = "Louisiana";
  UsaProvince["MAINE"] = "Maine";
  UsaProvince["MARYLAND"] = "Maryland";
  UsaProvince["MASSACHUSETTS"] = "Massachusetts";
  UsaProvince["MICHIGAN"] = "Michigan";
  UsaProvince["MINNESOTA"] = "Minnesota";
  UsaProvince["MISSISSIPPI"] = "Mississippi";
  UsaProvince["MISSOURI"] = "Missouri";
  UsaProvince["MONTANA"] = "Montana";
  UsaProvince["NEBRASKA"] = "Nebraska";
  UsaProvince["NEVADA"] = "Nevada";
  UsaProvince["NEW_HAMPSHIRE"] = "New Hampshire";
  UsaProvince["NEW_JERSEY"] = "New Jersey";
  UsaProvince["NEW_MEXICO"] = "New Mexico";
  UsaProvince["NEW_YORK"] = "New York";
  UsaProvince["NORTH_CAROLINA"] = "North Carolina";
  UsaProvince["NORTH_DAKOTA"] = "North Dakota";
  UsaProvince["NORTHERN_MARIANA_ISLANDS"] = "Northern Mariana Islands";
  UsaProvince["OHIO"] = "Ohio";
  UsaProvince["OKLAHOMA"] = "Oklahoma";
  UsaProvince["OREGON"] = "Oregon";
  UsaProvince["PENNSYLVANIA"] = "Pennsylvania";
  UsaProvince["PUERTO_RICO"] = "Puerto Rico";
  UsaProvince["RHODE_ISLAND"] = "Rhode Island";
  UsaProvince["SOUTH_CAROLINA"] = "South Carolina";
  UsaProvince["SOUTH_DAKOTA"] = "South Dakota";
  UsaProvince["TENNESSEE"] = "Tennessee";
  UsaProvince["TEXAS"] = "Texas";
  UsaProvince["US_VIRGIN_ISLANDS"] = "U.S. Virgin Islands";
  UsaProvince["UTAH"] = "Utah";
  UsaProvince["VERMONT"] = "Vermont";
  UsaProvince["VIRGINIA"] = "Virginia";
  UsaProvince["WASHINGTON"] = "Washington";
  UsaProvince["WEST_VIRGINIA"] = "West Virginia";
  UsaProvince["WISCONSIN"] = "Wisconsin";
  UsaProvince["WYOMING"] = "Wyoming";
})(UsaProvince || (exports.UsaProvince = UsaProvince = {}));
exports.usaProvinceToStateCode = {
  [UsaProvince.ALABAMA]: 'AL',
  [UsaProvince.ALASKA]: 'AK',
  [UsaProvince.AMERICAN_SAMOA]: 'AS',
  [UsaProvince.ARIZONA]: 'AZ',
  [UsaProvince.ARKANSAS]: 'AR',
  [UsaProvince.CALIFORNIA]: 'CA',
  [UsaProvince.COLORADO]: 'CO',
  [UsaProvince.CONNECTICUT]: 'CT',
  [UsaProvince.DELAWARE]: 'DE',
  [UsaProvince.DISTRICT_OF_COLUMBIA]: 'DC',
  [UsaProvince.FLORIDA]: 'FL',
  [UsaProvince.GEORGIA]: 'GA',
  [UsaProvince.GUAM]: 'GU',
  [UsaProvince.HAWAII]: 'HI',
  [UsaProvince.IDAHO]: 'ID',
  [UsaProvince.ILLINOIS]: 'IL',
  [UsaProvince.INDIANA]: 'IN',
  [UsaProvince.IOWA]: 'IA',
  [UsaProvince.KANSAS]: 'KS',
  [UsaProvince.KENTUCKY]: 'KY',
  [UsaProvince.LOUISIANA]: 'LA',
  [UsaProvince.MAINE]: 'ME',
  [UsaProvince.MARYLAND]: 'MD',
  [UsaProvince.MASSACHUSETTS]: 'MA',
  [UsaProvince.MICHIGAN]: 'MI',
  [UsaProvince.MINNESOTA]: 'MN',
  [UsaProvince.MISSISSIPPI]: 'MS',
  [UsaProvince.MISSOURI]: 'MO',
  [UsaProvince.MONTANA]: 'MT',
  [UsaProvince.NEBRASKA]: 'NE',
  [UsaProvince.NEVADA]: 'NV',
  [UsaProvince.NEW_HAMPSHIRE]: 'NH',
  [UsaProvince.NEW_JERSEY]: 'NJ',
  [UsaProvince.NEW_MEXICO]: 'NM',
  [UsaProvince.NEW_YORK]: 'NY',
  [UsaProvince.NORTH_CAROLINA]: 'NC',
  [UsaProvince.NORTH_DAKOTA]: 'ND',
  [UsaProvince.NORTHERN_MARIANA_ISLANDS]: 'MP',
  [UsaProvince.OHIO]: 'OH',
  [UsaProvince.OKLAHOMA]: 'OK',
  [UsaProvince.OREGON]: 'OR',
  [UsaProvince.PENNSYLVANIA]: 'PA',
  [UsaProvince.PUERTO_RICO]: 'PR',
  [UsaProvince.RHODE_ISLAND]: 'RI',
  [UsaProvince.SOUTH_CAROLINA]: 'SC',
  [UsaProvince.SOUTH_DAKOTA]: 'SD',
  [UsaProvince.TENNESSEE]: 'TN',
  [UsaProvince.TEXAS]: 'TX',
  [UsaProvince.US_VIRGIN_ISLANDS]: 'VI',
  [UsaProvince.UTAH]: 'UT',
  [UsaProvince.VERMONT]: 'VT',
  [UsaProvince.VIRGINIA]: 'VA',
  [UsaProvince.WASHINGTON]: 'WA',
  [UsaProvince.WEST_VIRGINIA]: 'WV',
  [UsaProvince.WISCONSIN]: 'WI',
  [UsaProvince.WYOMING]: 'WY'
};
var PeruProvince;
(function (PeruProvince) {
  PeruProvince["AMAZONAS"] = "Amazonas";
  PeruProvince["ANCASH"] = "Ancash";
  PeruProvince["APURIMAC"] = "Apurimac";
  PeruProvince["AREQUIPA"] = "Arequipa";
  PeruProvince["AYACUCHO"] = "Ayacucho";
  PeruProvince["CAJAMARCA"] = "Cajamarca";
  PeruProvince["CUSCO"] = "Cusco";
  PeruProvince["EL_CALLAO"] = "El Callao";
  PeruProvince["HUANCAVELICA"] = "Huancavelica";
  PeruProvince["HUANUCO"] = "Huanuco";
  PeruProvince["ICA"] = "Ica";
  PeruProvince["JUNIN"] = "Junin";
  PeruProvince["LA_LIBERTAD"] = "La Libertad";
  PeruProvince["LAMBAYEQUE"] = "Lambayeque";
  PeruProvince["LIMA"] = "Lima";
  PeruProvince["LORETO"] = "Loreto";
  PeruProvince["MADRE_DE_DIOS"] = "Madre de Dios";
  PeruProvince["MOQUEGUA"] = "Moquegua";
  PeruProvince["PASCO"] = "Pasco";
  PeruProvince["PIURA"] = "Piura";
  PeruProvince["PUNO"] = "Puno";
  PeruProvince["SAN_MARTIN"] = "San Martin";
  PeruProvince["TACNA"] = "Tacna";
  PeruProvince["TUMBES"] = "Tumbes";
  PeruProvince["UCAYALI"] = "Ucayali";
})(PeruProvince || (exports.PeruProvince = PeruProvince = {}));
//# sourceMappingURL=data:application/json;base64,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